<template>
    <div class="hotel-detail">
        <a
            :href="url"
            target="_blank"
        >
            <h3>{{ name }}</h3>
        </a>
        <div>
            <div class="address">
                <div class="address-line-1">{{ address }}</div>
                <div class="city">{{ city }}</div>
                <div class="zip">{{ zip }}</div>
            </div>
            <p class="block-link" v-if="blockLink">
                <a 
                    :href="blockLink"
                    target="_blank"
                >Special block rates available</a>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'hotel',
    props: [
        'name',
        'address',
        'city',
        'zip',
        'blockLink',
        'url'
    ]
};
</script>



// WEBPACK FOOTER //
// src/components/hotel-info.vue?cfc0f75e